import { AnimatePresence } from 'framer-motion';
import { useAddContentModal } from '@/features/events/components/AddContent';
import { useCustomizeMode } from '@/features/experiences/components/CustomizeMode';
import { usePageExperienceContext } from '@/features/experiences/contexts/PageExperienceContext';
import { MagicCtaButton } from '@/features/magic/components/MagicCtaButton';
import { useFeatureFlag } from '@/hooks/useFeatureFlag';
import { MotionFlex } from '@/ui';

type Props = {
  size?: string;
};

export const MagicButton = ({ size = 'sm' }: Props) => {
  const { value: plannerAddContentEnabled } = useFeatureFlag(
    'plannerAddContentEnabled'
  );
  const { readOnly } = usePageExperienceContext();
  const { open } = useAddContentModal();
  const { isMagicMode, isCustomizeModeActive } = useCustomizeMode();

  if (readOnly || !plannerAddContentEnabled) {
    return null;
  }

  // Hide while the add-content panel OR customize mode is open: the button
  // collapses its width to 0 so the controls to its right slide over to fill the
  // space. `initial={false}` suppresses the collapse/expand on first render.
  return (
    <AnimatePresence initial={false}>
      {!isMagicMode && !isCustomizeModeActive && (
        <MotionFlex
          animate={{ width: 'auto', opacity: 1 }}
          exit={{ width: 0, opacity: 0 }}
          // overflow:hidden (for the collapse animation) means shrinking clips
          // the label rather than eliding it, so never shrink.
          flexShrink={0}
          initial={{ width: 0, opacity: 0 }}
          key="magic-button"
          overflow="hidden"
          transition={{ duration: 0.22, ease: [0.4, 0, 0.2, 1] }}
        >
          <MagicCtaButton
            prominent
            size={size}
            onClick={() => open({ workflow: 'edits' })}
          >
            Chat to edit
          </MagicCtaButton>
        </MotionFlex>
      )}
    </AnimatePresence>
  );
};
